import React from "react";
import { useNavigate } from "react-router-dom";
import { Compass, Search, Home } from "lucide-react";
import SEO from "../components/SEO";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="not-found">
      <SEO title="Página não encontrada" description="O endereço acessado não existe no Guia de Jampa AI."
        path="/404" noindex />
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
          <Compass className="w-8 h-8 text-primary" />
        </div>
        <h1 className="font-heading font-extrabold text-3xl">Página não encontrada</h1>
        <p className="text-muted-foreground mt-2">O endereço acessado não existe ou foi removido.</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <button data-testid="notfound-home" onClick={() => navigate("/")}
            className="rounded-full bg-primary text-primary-foreground px-5 py-3 font-semibold flex items-center gap-2 active:scale-95 transition-transform">
            <Home className="w-4 h-4" /> Voltar para o Guia
          </button>
          <button data-testid="notfound-search" onClick={() => navigate("/empresas")}
            className="rounded-full border border-border px-5 py-3 font-semibold flex items-center gap-2 active:scale-95 transition-transform">
            <Search className="w-4 h-4" /> Pesquisar no Guia
          </button>
        </div>
      </div>
    </div>
  );
}
